module.exports = __webpack_public_path__ + "static/img/ajlogo1.b924c3b5.svg";